import { render, staticRenderFns } from "./CuponsCard.vue?vue&type=template&id=4b8f378f&scoped=true"
import script from "./CuponsCard.vue?vue&type=script&lang=js"
export * from "./CuponsCard.vue?vue&type=script&lang=js"
import style0 from "./CuponsCard.vue?vue&type=style&index=0&id=4b8f378f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f378f",
  null
  
)

export default component.exports